import { render, staticRenderFns } from "./SelectProjectStep.vue?vue&type=template&id=5b3f0714&scoped=true&"
import script from "./SelectProjectStep.vue?vue&type=script&lang=js&"
export * from "./SelectProjectStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f0714",
  null
  
)

export default component.exports